(function (window) {
  'use strict';

  const state = window.__CURACAO_MINICART_STATE__ || {
    lastAdded: null
  };
  window.__CURACAO_MINICART_STATE__ = state;

  function toInt(value) {
    const parsed = parseInt(value, 10);
    return Number.isNaN(parsed) ? null : parsed;
  }

  function toIdStr(value) {
    if (value == null || value === '') return '';
    return String(value);
  }

  function parseFormVariantId(form) {
    if (!form || typeof FormData === 'undefined') return null;
    if (!(form instanceof FormData)) return null;
    return toInt(form.get('id'));
  }

  function isCartResponse(response) {
    return !!(response && Array.isArray(response.items) && typeof response.item_count === 'number');
  }

  function findLineItemInCart(items, variantId) {
    const target = toIdStr(variantId);
    if (!items || !items.length || !target) return null;

    for (let i = 0; i < items.length; i += 1) {
      const item = items[i];
      if (toIdStr(item.variant_id) === target || toIdStr(item.id) === target) {
        return item;
      }
    }

    return null;
  }

  function findLineItemByProductIdMaxQty(items, productId, variantId) {
    if (!items || !items.length) return null;

    const targetProductId = toIdStr(productId);
    if (!targetProductId) return null;

    let best = null;

    for (let i = 0; i < items.length; i += 1) {
      const item = items[i];
      if (toIdStr(item.product_id) !== targetProductId) continue;
      if (variantId && toIdStr(item.variant_id) === toIdStr(variantId)) {
        return item;
      }
      if (!best || item.quantity > best.quantity) {
        best = item;
      }
    }

    return best;
  }

  function resolveAddedLineItem(eventDetail) {
    if (!eventDetail) return null;

    const response = eventDetail.response || {};
    let variantId = toInt(response.variant_id || response.id);

    if (!variantId) {
      variantId = parseFormVariantId(eventDetail.form);
    }

    if (isCartResponse(response)) {
      let matchedItem = findLineItemInCart(response.items, variantId);
      if (matchedItem) {
        return normalizeLineItem(matchedItem);
      }

      let productId = toInt(response.product_id);
      matchedItem = findLineItemByProductIdMaxQty(response.items, productId, variantId);
      if (matchedItem) {
        return normalizeLineItem(matchedItem);
      }

      if (variantId) {
        return {
          variantId: variantId,
          productId: productId,
          key: response.key || null
        };
      }

      return null;
    }

    if (response && !response.status) {
      return normalizeLineItem(response);
    }

    return null;
  }

  function normalizeLineItem(item) {
    if (!item) return null;

    return {
      variantId: item.variant_id || item.id || null,
      productId: item.product_id || null,
      key: item.key || null
    };
  }

  function normalize(eventDetail) {
    if (!eventDetail) return null;

    const lineItem = resolveAddedLineItem(eventDetail);
    if (!lineItem) return null;

    return {
      variantId: lineItem.variantId || null,
      productId: lineItem.productId || null,
      key: lineItem.key || (eventDetail.response && eventDetail.response.key) || null,
      updatedAt: Date.now()
    };
  }

  function persist(eventDetail) {
    const normalized = normalize(eventDetail);
    if (!normalized) return null;
    state.lastAdded = normalized;
    return normalized;
  }

  function get() {
    return state.lastAdded || null;
  }

  function clear() {
    state.lastAdded = null;
  }

  function buildMinicartUrl(lastAdded) {
    const url = (window.Shopify && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart?view=minicart';
    const query = [];

    if (lastAdded && lastAdded.key) {
      query.push('last_added_line_key=' + encodeURIComponent(lastAdded.key));
    }
    if (lastAdded && lastAdded.variantId) {
      query.push('last_added_variant_id=' + encodeURIComponent(lastAdded.variantId));
    }
    if (lastAdded && lastAdded.productId) {
      query.push('last_added_product_id=' + encodeURIComponent(lastAdded.productId));
    }
    if (query.length) {
      return url + '&' + query.join('&');
    }

    return url;
  }

  window.CuracaoMiniCartLastAdded = {
    persist: persist,
    get: get,
    clear: clear,
    buildMinicartUrl: buildMinicartUrl
  };
}(window));
